import Sortable from 'sortablejs';
import $ from 'jquery';

/**
 * checkBetriebClick
 * @param element
 */
window.checkBetriebClick = function(element) {
  document.querySelectorAll(element).forEach(el => el.addEventListener('click', event => {
    const isCheckbox = event.target.closest('div').classList.contains('form-field--checkbox');
    const isMove = event.target.closest('div').classList.contains('move');

    if (!isCheckbox && !isMove) {
      const row = event.target.closest('div.row-betrieb');
      openBetriebDetails(Number(row.getAttribute('data-id')));
    }
  }));
};

/**
 * openBetriebDetails
 * @param id
 */
window.openBetriebDetails = function(id) {
  window.location = BASE_PATH + 'betriebsdaten/betriebeDetails/' + id;
};

/**
 * sortBetriebe
 */
window.sortBetriebe = function() {
  const tableBetriebe = document.getElementById('table-betriebe');

  Sortable.create(tableBetriebe, {
    handle: '.dragger',
    draggable: '.drag-row',
    animation: 150,
    easing: '',
    onEnd: function() {
      const elementIDs = [];
      Array.prototype.forEach.call(tableBetriebe.querySelectorAll('.drag-row'), function(element) {
        elementIDs.push(element.getAttribute('data-id'));
      });

      fetch(BASE_PATH + 'ajax/helper/additional/ajax.saveSorting', {
        method: 'POST',
        body: JSON.stringify({
          area: 'betriebe',
          elements: elementIDs,
        }),
      }).then(function(response) {
        return response.text();
      });
    },
  });
};

/**
 * vipLoginQDB
 * @param id
 */
window.vipLoginQDB = function(id) {
  insertAutoLoader($('body'));

  fetch(BASE_PATH + 'ajax/helper/betriebsdaten/ajax.vipAutoLogin', {
    method: 'POST',
    body: JSON.stringify({
      factoryID: id,
    }),
  }).then((response) => response.json()).then((data) => {
    if (data.url !== '') {
      window.open(data.url, '_blank');
      removeAutoLoader();
    }
  });
};